/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ page: NonNullable<unknown>, pages: NonNullable<unknown> }} Directory_External_Directories_Page_LabelInputs */

const en_directory_external_directories_page_label = /** @type {(inputs: Directory_External_Directories_Page_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Page ${i?.page} of ${i?.pages}`)
};

const zh_directory_external_directories_page_label = /** @type {(inputs: Directory_External_Directories_Page_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`第 ${i?.page} / ${i?.pages} 页`)
};

/**
* | output |
* | --- |
* | "Page {page} of {pages}" |
*
* @param {Directory_External_Directories_Page_LabelInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_external_directories_page_label = /** @type {((inputs: Directory_External_Directories_Page_LabelInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_External_Directories_Page_LabelInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_external_directories_page_label(inputs)
	return zh_directory_external_directories_page_label(inputs)
});
export { directory_external_directories_page_label as "directory.external_directories.page_label" }